import { render, staticRenderFns } from "./updateTag.vue?vue&type=template&id=c535d88e&scoped=true"
import script from "./updateTag.vue?vue&type=script&lang=js"
export * from "./updateTag.vue?vue&type=script&lang=js"
import style0 from "./updateTag.vue?vue&type=style&index=0&id=c535d88e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c535d88e",
  null
  
)

export default component.exports